var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHasSystemIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.643085 10C0.497285 10 0.342908 9.94783 0.222837 9.84348C-0.0430349 9.60869 -0.0773413 9.19999 0.154224 8.92172L4.09084 4.26078C4.51967 3.75643 5.13717 3.45207 5.78899 3.42599C6.4408 3.40859 7.08404 3.65208 7.54717 4.12165L8.36194 4.94775C8.57635 5.16514 8.8508 5.26949 9.15955 5.26949C9.45973 5.2608 9.73418 5.12166 9.93144 4.88688L13.8681 0.225936C14.0996 -0.0436335 14.5027 -0.0784169 14.7772 0.156369C15.043 0.391156 15.0773 0.799858 14.8458 1.07812L10.9092 5.73907C10.4803 6.24342 9.86283 6.54777 9.21101 6.57386C8.55062 6.59125 7.91596 6.34777 7.45283 5.8782L6.64664 5.0521C6.43223 4.8347 6.1492 4.72166 5.84902 4.73035C5.54885 4.73905 5.2744 4.87818 5.07714 5.11297L1.14052 9.77391C1.0033 9.92174 0.823192 10 0.643085 10Z",
    fill: "#1B234E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHasSystemIcon);
export default __webpack_public_path__ + "static/media/HasSystemIcon.2cc9b53e5a8185e5f7900e931056e635.svg";
export { ForwardRef as ReactComponent };